import getApiInstance from '@/api';
import { type BookingDTO } from '@/types/dto/agent';

export const fetchInitiateRefund = async (
  bookingId: BookingDTO['id'],
  fulfillmentIds: Array<string>
) => {
  if (!bookingId) {
    return null;
  }

  const api = (await getApiInstance()).agentApi;
  const response = await api.RefundOffers_InitiateRefund(
    { bookingId },
    { fulfillmentIds }
  );

  return response.data;
};
